import { ForwardedRef, ReactNode, forwardRef } from 'react'
import { twMerge } from 'tailwind-merge'
import { faTimes } from '../../icons/light'
import { Icon } from '../Icon/Icon'
import { Button } from '../Button/Button'
import { Merge } from '../../util/types'

export interface CoreInputProps {
  label?: ReactNode
  icon?: ReactNode
  unit?: ReactNode
  description?: ReactNode
  error?: ReactNode
  onClear?: () => void
  className?: string | undefined
}

export type InputProps = Merge<React.ComponentProps<'input'>, CoreInputProps>

export const Input = forwardRef(
  function Input (props: InputProps, ref: ForwardedRef<HTMLInputElement>) {
    const {
      label,
      icon,
      unit,
      description,
      error,
      className,
      onClear,
      ...inputProps
    } = props

    return (
      <div className={twMerge('core-input typo-body flex-1 space-y-1 text-black', className)}>

        <label className='flex flex-col gap-1 text-black'>
          {Boolean(label) && (
            <div className='typo-body-medium font-medium text-gray-600'>
              {label}
            </div>
          )}

          <div className={twMerge(
            'flex h-9 items-center rounded border-2 bg-white pl-3',
            error != null ? 'border-red-500' : 'border-gray-200',
            'focus-within:border-black'
          )}
          >
            {Boolean(icon) && (
              <div className='mr-3 flex h-4 w-4 items-center justify-center text-gray-600'>
                {icon}
              </div>
            )}

            <input
              ref={ref}
              {...inputProps}
              value={inputProps.value}
              className='mr-3 h-full flex-1 border-none outline-none'
            />

            {Boolean(unit) && (
              <div className='flex h-full items-center justify-center p-3 text-gray-600'>
                {unit}
              </div>
            )}

            {Boolean(onClear) && (
              <Button
                onClick={onClear}
                variant='plain' className='flex h-full w-8 items-center justify-center text-gray-400'
              >
                <Icon icon={faTimes} />
              </Button>
            )}

          </div>

        </label>

        {Boolean(description) && (
          <div className='typo-caption font-medium text-gray-600'>
            {description}
          </div>
        )}

        {Boolean(error) && (
          <div className='typo-caption font-medium text-red-500'>
            {error}
          </div>
        )}

      </div>
    )
  }
)
